import { createRoot } from "react-dom/client";
import { App } from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider, defaultTheme } from "@adobe/react-spectrum";
import React from "react";

import "./index.scss";

const container = document.getElementById("app");
const root = createRoot(container ?? document.body);
root.render(
  <Provider theme={defaultTheme}>
    <GoogleOAuthProvider
      clientId={
        process.env.NODE_ENV === "development"
          ? "814918986589-qka4e49jtdjs2bici62fnvllqf3gup9a.apps.googleusercontent.com"
          : "814918986589-1k36m99d30d61vrskpp08f1sn9rn6kcn.apps.googleusercontent.com"
      }
    >
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </GoogleOAuthProvider>
  </Provider>
);
